/**
 * Route for `capi-test-event-mode-for-verification`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CapiTestEventModeForVerificationPage } from "../features/capi-test-event-mode-for-verification/CapiTestEventModeForVerificationPage";

export const capiTestEventModeForVerificationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/capi-test-event-mode-for-verification",
	component: CapiTestEventModeForVerificationPage,
});

export default capiTestEventModeForVerificationRoute;
